module.exports = __webpack_public_path__ + "static/img/77071F_8_R_20200801_LC.fdd760f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77071F_8_R_20200801_LC.png
// module id = moRt
// module chunks = 0